// extracted by mini-css-extract-plugin
module.exports = {"sizeList":"sizes_sizeList__qfh_I","sizeBtn":"sizes_sizeBtn__CgwJL","sizeBtnDisabled":"sizes_sizeBtnDisabled__ua1oP","sizeBtnSelected":"sizes_sizeBtnSelected__j6mrt"};